<template>
  <div>
    <el-row>
      <el-col :span="24">
        <p>终稿-未翻/通过部分为原文</p>
        <fileDown
          v-if="this.orderId"
          :fileOption="{title:'还原后PE稿'}"
          :taskType="4"
          :type="4"
          :orderId="this.orderId"
          key="pe"/>
      </el-col>
      <el-col :span="24">
        <p>终稿-未翻部分为译文（未审核的还原为最后一次PE结果，未PE的还原为机翻译文）</p>
        <fileDown
          v-if="this.orderId"
          :taskType="4"
          :type="12"
          :orderId="this.orderId" key="pe"/>
      </el-col>
      <el-col :span="24">
        <p>平行语料稿-未翻/通过部分为原文</p>
        <fileDown
          v-if="this.orderId"
          :taskType="4"
          :type="5"
          :orderId="this.orderId" key="excel"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import fileDown from '@/views/common/fileDown'

export default {
  components: {fileDown},
  props: ['orderId'],
  data() {
    return {
      childOrderId: this.orderId,
      page: false,
      stripe: true,
      peFiles: [],
      excelFiles: [],
      isViewPdf: false,
      pdfSrc: '',
      allDownArr: [],
    }
  },
  computed: {},
  mounted() {

  },
}
</script>
<style lang="scss">
.el-card {
  background: #fafafa;

  .el-card__header {
    padding: 12px 20px;
  }

  .card_cont {
    .p1 {
      font-size: 16px;
      margin: 0;
    }

    .note {
      font-size: 12px;
      margin: 0;
    }

    .card_ul {
      > li {
        width: 100%;
        list-style-type: none;

        > span {
          width: 30%;
          display: inline-block;
          margin-right: 3%;
          font-size: 14px;
        }

        button {
          font-size: 14px;
        }
      }
    }
  }
}

</style>

